import React from 'react';
import PropTypes from 'prop-types';

class SimpleHTML extends React.Component {
  render() {
    if (this.props.message.length > 0) {
      var displayText = [];
      for (var i = 0; i < this.props.message.length; i++) {      
        displayText.push(<div key={i}><span>{this.props.message[i]}</span></div>);
      }

      return displayText;
    }
    else
      return null;
  }
}

SimpleHTML.propTypes = {
  message: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default SimpleHTML;
